let exdate = new Date();
exdate.setDate(exdate.getDate() + 30);

const domainValue = (nodeEnv) => {
  switch (nodeEnv) {
    case 'production':
      return '.graphcms.com';
    case 'preview':
      return '.graphcms.vercel.app';
    default:
      return '.localhost:8000';
  }
};

const cookieParams = {
  domain: domainValue(process.env.NODE_ENV),
  sameSite: 'lax',
  path: '/',
  expires: exdate,
};

module.exports = cookieParams;
